import React from "react";
import {
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    ViberIcon,
    ViberShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from "react-share";
import forwardArrow from "../../../assets/icons/forward.svg";
import { useNavigate } from "react-router-dom";
import { playSong } from '../../common/actions/common.actions';
import { useDispatch } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import { IoMdShare } from "react-icons/io";

export const Share = () => {
    const shareUrl = window.location.href.split('/').slice(0, 3).join('/');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleClick = () => {
        handleSongClick();
        navigate('/dashboard');
    };

    return (
        <div className="w-full h-[100dvh] flex flex-col overflow-hidden bg-gradient-to-br from-silver via-gray-100 to-silver relative">
            {/* Professional Header */}
            <div className="relative z-10 bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl border-b-2 border-crimson/40 shadow-2xl">
                <div className="flex justify-between items-center px-5 py-4">
                    <button
                        onClick={handleClick}
                        className="w-10 h-10 flex justify-center items-center text-blue-primary hover:bg-crimson/10 rounded-xl transition-all duration-300"
                    >
                        <IoIosArrowBack size={24} />
                    </button>
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-gradient-to-br from-crimson via-red-primary to-crimson rounded-xl flex items-center justify-center shadow-lg border-2 border-golden/40">
                            <IoMdShare size={22} className="text-white drop-shadow-lg" />
                        </div>
                        <h3 className="text-lg font-bold text-blue-primary leading-tight">Share</h3>
                    </div>
                    <div className="w-10"></div>
                </div>
                {/* Luxury Border Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-crimson via-golden to-crimson shadow-lg"></div>
            </div>

            {/* Share Buttons Content */}
            <div className="relative z-10 flex flex-1 justify-center items-center px-4">
                <div className="bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl rounded-2xl border-2 border-crimson/30 shadow-lg p-8">
                    <div className="flex flex-wrap justify-center items-center gap-6">
                        <FacebookShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <FacebookIcon size={50} round={true} />
                        </FacebookShareButton>
                        <FacebookMessengerShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <FacebookMessengerIcon size={50} round={true} />
                        </FacebookMessengerShareButton>
                        <TwitterShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <TwitterIcon size={50} round={true} />
                        </TwitterShareButton>
                        <TelegramShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <TelegramIcon size={50} round={true} />
                        </TelegramShareButton>
                        <WhatsappShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <WhatsappIcon size={50} round={true} />
                        </WhatsappShareButton>
                        <ViberShareButton url={shareUrl} className="transition-transform duration-200 hover:scale-110">
                            <ViberIcon size={50} round={true} />
                        </ViberShareButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
